'use client';
import { ReactNode, createContext } from 'react';
import type { StorefrontItemBody, StorefrontPrice } from '@/api/menu-list/storefront-menu-snapshot.types';
import type { ResolvedStorefrontItem } from '@/entities/product/lib/storefront-menu';
import type { LocalizedString } from '@/shared/model/Language';

export type MenuItemData = {
    hash: string;
    slug: LocalizedString;
    itemId: string;
    item: StorefrontItemBody;
    menuListId: string | null;
    categoryId: string;
    sortIndex?: number;
    overrideItem?: { prices?: StorefrontPrice[] } | null;
};

export const MenuItemContext = createContext<{
    data: MenuItemData;
    index: number;
    itemsIndex?: Record<string, ResolvedStorefrontItem>;
}>({
    data: {
        item: { id: '', name: { CS: 'Polozka', EN: 'Item' }, prices: [], assets: [] },
        itemId: '',
        menuListId: null,
        categoryId: '',
        hash: '',
        slug: {},
    },
    index: 0,
});

type Props = {
    value: {
        data: MenuItemData;
        index: number;
        itemsIndex?: Record<string, ResolvedStorefrontItem>;
    };
    children?: ReactNode;
};

export const MenuItemProvider = ({ value, children }: Props) => {
    return <MenuItemContext.Provider value={value}>{children}</MenuItemContext.Provider>;
};
